import api from '@/api'

export default {
    /**
     * 현재 로그인 되어 있는 사용자의 회사에 설정된 모든 템플릿 목록을 조회합니다.
     * @returns {Promise<webpart.WebpartTemplate[]>} 템플릿 목록
     */
    get(comCode: string): Promise<webpartv3.WebpartTemplate[]> {
        return api.get({
            url: `/Webpart/WebpartTemplate/api/getlist?comCode=${comCode}`,
        })
    },

    /**
     * 웹파트 페이지 선택에 따라 템플릿 목록을 조회합니다.
     * @param {number} pageid 페이지 아이디
     */
    getByPageId(pageid: number): Promise<webpartv3.WebpartTemplate[]> {
        return api.get({
            url: `/Webpart/WebpartTemplate/api/page?id=${pageid}`,
        })
    },
        
    /**
     * 템플릿를 저장합니다.
     * @param template 저장할 템플릿 데이터
     */
    save(template: webpartv3.WebpartTemplate): Promise<webpartv3.WebpartTemplate> {
        return api.post({
            url: '/Webpart/WebpartTemplate/api/create',
            data: template,
        })
    },

    /**
     * 지정된 아이디를 가지는 템플릿를 삭제합니다.
     * @param {number} id 삭제할 템플릿 아이디
     */
    delete(id: string): Promise<boolean> {
        return api.delete<boolean>({
            url: `/Webpart/WebpartTemplate/api/delete?id=${id}`,
        })
    },
}
